/**
 * Admin cross-tenant integrations read-only hook (Batch 21a-3 §5).
 */
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

interface IntegrationListItem {
  id: string;
  tenant_id: string;
  tenant_slug: string;
  tenant_name: string;
  type: string;
  name: string;
  is_active: boolean;
  created_by_user_id: string;
  created_by_email: string | null;
  created_at: string;
  last_synced_at: string | null;
  last_rotated_at: string | null;
  sync_counts_30d: {
    success: number;
    partial: number;
    failed: number;
    running: number;
  };
}

interface ListIntegrationsResponse {
  integrations: IntegrationListItem[];
  next_cursor: string | null;
}

export function useAdminIntegrations(status: "all" | "active" | "inactive" = "all") {
  return useQuery<ListIntegrationsResponse, ApiError>({
    queryKey: ["admin", "integrations", { status }],
    queryFn: async () => {
      const r = await apiClient.get<ListIntegrationsResponse>("/admin/integrations", {
        params: { status },
      });
      return r.data;
    },
  });
}
